// Renders a clip card with optional attribution chips.

import React from 'react';
import { Link } from 'react-router';
import {
  findGameDiscoverySlug,
  findGameName,
} from '@airhead-games/shared/utilities/getGames';
import { Badge } from '../ui/badge';
import TwitchEmbed from './TwitchEmbed';

interface CardProps {
  clipUrl: string;
  streamerName: string;
  gameId: string;
  width?: number;
  height?: number;
  showGameChip?: boolean;
  showChips?: boolean;
  eager?: boolean;
  interactive?: boolean;
  onLoad?: () => void;
}

const Card: React.FC<CardProps> = ({
  clipUrl,
  streamerName,
  gameId,
  width = 534,
  height = 300,
  showGameChip = true,
  showChips = true,
  eager = false,
  interactive = true,
  onLoad,
}) => {
  const gameName = findGameName(gameId);
  const gameSlug = findGameDiscoverySlug(gameId);

  return (
    <div
      className="flex w-full max-w-full flex-col items-center gap-2"
      style={{ maxWidth: width }}
    >
      <TwitchEmbed
        clipUrl={clipUrl}
        width={width}
        height={height}
        eager={eager}
        interactive={interactive}
        onLoad={onLoad}
      />
      {interactive && showChips && (
        <div className="flex flex-wrap justify-center gap-2">
          <Badge
            asChild
            className="h-8 rounded-full px-3 text-sm"
            variant="secondary"
          >
            <Link to={`/discover/clips?streamer=${streamerName}`}>
              {streamerName}
            </Link>
          </Badge>
          {showGameChip && gameName && gameSlug && (
            <Badge
              asChild
              className="h-8 rounded-full px-3 text-sm"
              variant="secondary"
            >
              <Link to={`/discover/clips?game=${gameSlug}`}>{gameName}</Link>
            </Badge>
          )}
        </div>
      )}
    </div>
  );
};

export default Card;
